<template>
  <svg :height="height" :width="width" id="YPO" viewBox="0 0 239.3885 102.7261">
    <rect class="a" x="-18.6217" y="-16.7383" width="277.5999" height="139.3356"/>
    <path class="b"
          d="M209.5434,36.6512a15.9673,15.9673,0,1,1-15.9672,15.9672,15.9853,15.9853,0,0,1,15.9672-15.9672m0-5.9931a21.96,21.96,0,1,0,21.96,21.96,21.96,21.96,0,0,0-21.96-21.96Z"/>
    <path class="b"
          d="M157.1316,55.6858V37.3484h10.5622a9.17,9.17,0,0,1,0,18.34Zm10.5622-24.33H150.7179V73.8816h6.4137v-12.2h10.5622a15.1633,15.1633,0,0,0,0-30.3265h0"/>
    <polygon class="b"
             points="138.602 31.355 126.251 52.749 113.899 31.355 106.541 31.355 123.044 59.938 123.044 73.882 129.416 73.882 129.416 60.011 145.96 31.355 138.602 31.355"/>
    <polygon class="b"
             points="33.277 81.01 25.134 66.909 25.148 66.909 25.143 66.9 25.134 66.9 25.138 66.89 8.853 95.101 41.412 95.101 33.278 81.01 33.277 81.01"/>
    <polygon class="b"
             points="90.259 66.9 90.255 66.909 90.259 66.909 82.121 81.008 82.123 81.008 73.981 95.111 106.541 95.111 90.259 66.9"/>
    <polygon class="b" points="57.709 38.696 73.99 38.696 57.709 10.491 41.425 38.696 57.705 38.696 57.709 38.696"/>
    <polygon class="b" points="33.28 81 49.551 81 41.415 66.915 33.28 81"/>
    <polygon class="b" points="82.112 81 73.978 66.915 65.841 81 82.112 81"/>
    <polygon class="b" points="65.83 52.801 57.694 38.707 49.558 52.797 49.56 52.801 65.83 52.801"/>
    <polygon class="b" points="73.974 95.112 65.837 81.019 57.699 95.112 73.974 95.112"/>
    <polygon class="b" points="49.556 81.018 41.418 95.111 57.689 95.111 57.692 95.107 49.556 81.018"/>
    <polygon class="b"
             points="41.408 66.9 33.271 52.807 33.28 52.807 33.278 52.801 33.278 52.798 33.277 52.797 25.138 66.89 25.143 66.9 41.408 66.9"/>
    <polygon class="b"
             points="82.115 52.801 82.111 52.807 82.115 52.807 73.981 66.9 90.259 66.9 82.121 52.801 82.115 52.801"/>
    <polygon class="b" points="49.551 52.801 41.411 38.707 33.279 52.799 33.279 52.801 49.551 52.801"/>
    <polygon class="b"
             points="82.115 52.801 82.115 52.797 82.121 52.801 82.123 52.801 73.981 38.695 65.836 52.797 65.84 52.801 82.115 52.801"/>
    <path class="b"
          d="M63.7842,66.9h10.185L65.8316,52.8094l-5.0908,8.8175-3.0447-5.275-3.0486,5.2794L49.5529,52.81,41.4167,66.9H51.605l-3.03,5.2469h6.0995l-5.1138,8.8535h16.27L60.7181,72.147h6.0946Zm-6.0881-8.2918L64.86,71.02H50.53Z"/>
  </svg>
</template>

<script>
export default {
  name: 'IconYpoWithText',
  props: {
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
  },
};
</script>

<style scoped>
.a {
  fill: none;
}
.b {
  fill: #041e42;
}
</style>
